import { useEffect } from "react";
import { useNavigate } from "react-router";
import { AuthenticationFactory } from "../services/Auth/AuthenticationFactory";

const SiteminderLoginPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const attemptLogin = async () => {
      const loginDenied = sessionStorage.getItem("loginDenied");

      console.warn("[SiteminderLoginPage] loginDenied flag:", loginDenied);

      if (loginDenied === "true") {
        // Stop the loop — don't try login again
        console.warn(
          "[SiteminderLoginPage] Skipping redirect due to loginDenied flag."
        );
        return;
      }

      console.log(
        "[SiteminderLoginPage] Forcing fresh login to SiteMinder..."
      );

      // Clear any previous login denial flag
      sessionStorage.removeItem("loginDenied");

      const authType =
        import.meta.env.VITE_AUTH_PROVIDER?.replace(/['"]+/g, "") ||
        "siteminder";

      const authService =
        AuthenticationFactory.getAuthService(authType);

      try {
        await authService.login(); // Triggers userManager.signinRedirect()
      } catch (err) {
        console.error(
          "[SiteminderLoginPage] Login redirect failed",
          err
        );
        navigate("/error");
      }
    };

    attemptLogin();
  }, [navigate]);

  const loginDenied =
    sessionStorage.getItem("loginDenied");

  return (
    <div>
      {loginDenied === "true"
        ? "ODP access was denied by SiteMinder. Please logout from other portals and try again."
        : "Redirecting to ODP- SiteMinder login..."}
    </div>
  );
};

export default SiteminderLoginPage;